import * as api from './api';
import camelcaseKeys from 'camelcase-keys';

export const ADD_FOLDER = 'add_folder';
export const ADD_DOCUMENT = 'add_document';
export const UPDATE_DOCUMENT = 'update_document';
export const UPDATE_FOLDER = 'update_folder';
export const REMOVE_DOCUMENT = 'remove_document';
export const SEARCH_DOCUMENTS = 'search_documents';
export const DELETE_FOLDER = 'delete_folder';
export const FETCH_FOLDER = 'fetch_folder';
export const HIGHLIGHT_DOCUMENT = 'highlight_document';

export function searchDocuments(projectId, marketing, searchText) {
  return (dispatch) => {
    return api.searchDocuments(projectId, marketing, searchText).then((data) => {
      dispatch({
        type: SEARCH_DOCUMENTS,
        payload: data
      });
    });
  };
}

export function fetchFolder(projectId, folderId, highlightDocumentId) {
  return (dispatch) => {
    return api.fetchFolder(projectId, folderId).then((data) => {
      dispatch({
        type: FETCH_FOLDER,
        payload: data.folder
      });
      if (highlightDocumentId) {
        return dispatch(highlightDocument(highlightDocumentId));
      }
    });
  };
}

export function highlightDocument(highlightDocumentId) {
  return (dispatch) => {
    dispatch({
      type: HIGHLIGHT_DOCUMENT,
      payload: highlightDocumentId
    });

    setTimeout(() => {
      dispatch({
        type: HIGHLIGHT_DOCUMENT,
        payload: null
      });
    }, 2000);
  };
}

export function createFolder(projectId, parentId, marketing = false) {
  return (dispatch) => {
    return api.createFolder(projectId, parentId, marketing).then((data) =>{
      dispatch({
        type: ADD_FOLDER,
        payload: data
      });
    });
  };
}

export function uploadDocument(projectId, projectType, marketing, folderId, file, headFolderId = null, leaseSpaceId = null) {
  return (dispatch) => {
    return api.uploadDocument(projectId, projectType, marketing, folderId, file, headFolderId, leaseSpaceId).then((res) => {
      const data = camelcaseKeys(res.data, { deep: true });
      if (data.folder) {
        dispatch({
          type: ADD_FOLDER,
          payload: data
        });
      } else {
        dispatch({
          type: ADD_DOCUMENT,
          payload: data
        });
      }
      return data;
    });
  };
}

export function updateDocument(documentId, docsDocument) {
  return (dispatch) => {
    return api.updateDocument(documentId, docsDocument).then((data) => {
      dispatch({
        type: UPDATE_DOCUMENT,
        payload: data
      });
    });
  };
}

export function updateFolder(id, projectDocumentFolder) {
  return (dispatch, getState) => {
    const projectId = getState().project.id;

    return api.updateFolder(projectId, id, projectDocumentFolder).then((data) => {
      dispatch({
        type: UPDATE_FOLDER,
        payload: data
      });
    });
  };
}

export function deleteDocument(id) {
  return (dispatch) => {
    return api.deleteDocument(id).then((data) => {
      dispatch({
        type: REMOVE_DOCUMENT,
        payload: data
      });
    });
  };
}

export function deleteFolder(id) {
  return (dispatch, getState) => {
    const projectId = getState().project.id;

    return api.deleteFolder(projectId, id).then(() => {
      dispatch({
        type: DELETE_FOLDER,
        payload: { id, folder: true }
      });
    });
  };
}

export function moveFolderToFolder(marketing, sourceId, targetId) {
  return (dispatch, getState) => {
    const payload = { id: sourceId, marketing, folder: true };
    const projectId = getState().project.id;
    const request = api.updateFolderParent(projectId, sourceId, targetId);

    return request.then(() => dispatch({ type: DELETE_FOLDER, payload }));
  };
}

export function toggleMarketing(marketing, sourceId, contextId, folder) {
  return (dispatch, getState) => {
    const payload =  folder ? {
      id: contextId, folder: true
    } : {
      document: { id: sourceId, marketing } 
    };

    const projectId = getState().project.id;

    const request = api.updateProjectDocumentMarketing(marketing, contextId, folder, projectId);
    const type = folder ? DELETE_FOLDER : REMOVE_DOCUMENT;

    return request.then(() => dispatch({ type, payload }));
  };
}

export function moveDocumentToFolder(marketing, sourceId, contextId, targetId) {
  return (dispatch) => {
    const payload = { document: { id: sourceId, marketing } };
    const request = api.updateProjectDocumentParent(contextId, targetId);

    return request.then(() => dispatch({ type: REMOVE_DOCUMENT, payload }));
  };
}

export function addAttachmentToProject(marketing, projectId, taskId, attachmentId) {
  return (dispatch) => {
    const request = api.addAttachmentToProject(marketing, projectId, taskId, attachmentId);

    return request.then(payload => dispatch({ type: ADD_DOCUMENT, payload }));
  };
}
